const android_osv_list = [
  { value: "0.0", label: "不限" },
  { value: "2.0", label: "Android 2.0 及以上" },
  { value: "2.1", label: "Android 2.1 及以上" },
  { value: "2.2", label: "Android 2.2 及以上" },
  { value: "2.3", label: "Android 2.3 及以上" },
  { value: "3.0", label: "Android 3.0 及以上" },
  { value: "3.1", label: "Android 3.1 及以上" },
  { value: "3.2", label: "Android 3.2 及以上" },
  { value: "4.0", label: "Android 4.0 及以上" },
  { value: "4.1", label: "Android 4.1 及以上" },
  { value: "4.2", label: "Android 4.2 及以上" },
  { value: "4.3", label: "Android 4.3 及以上" },
  { value: "4.4", label: "Android 4.4 及以上" },
  { value: "4.5", label: "Android 4.5 及以上" },
  { value: "5.0", label: "Android 5.0 及以上" },
  { value: "5.1", label: "Android 5.1 及以上" },
  { value: "6.0", label: "Android 6.0 及以上" },
  { value: "7.0", label: "Android 7.0 及以上" },
  { value: "7.1", label: "Android 7.1 及以上" },
  { value: "8.0", label: "Android 8.0 及以上" },
  { value: "8.1", label: "Android 8.1 及以上" },
  { value: "9.0", label: "Android 9.0 及以上" },
  { value: "10.0", label: "Android 10.0 及以上" },
  { value: "10.1", label: "Android 10.1 及以上" },
  { value: "11.0", label: "Android 11.0 及以上" },
];

const ios_osv_list = [
  { value: "0.0", label: "不限" },
  { value: "4.0", label: "IOS 4.0 及以上" },
  { value: "4.1", label: "IOS 4.1 及以上" },
  { value: "4.2", label: "IOS 4.2 及以上" },
  { value: "4.3", label: "IOS 4.3 及以上" },
  { value: "5.0", label: "IOS 5.0 及以上" },
  { value: "5.1", label: "IOS 5.1 及以上" },
  { value: "6.0", label: "IOS 6.0 及以上" },
  { value: "7.0", label: "IOS 7.0 及以上" },
  { value: "7.1", label: "IOS 7.1 及以上" },
  { value: "8.0", label: "IOS 8.0 及以上" },
  { value: "8.1", label: "IOS 8.1 及以上" },
  { value: "8.2", label: "IOS 8.2 及以上" },
  { value: "9.0", label: "IOS 9.0 及以上" },
  { value: "9.1", label: "IOS 9.1 及以上" },
  { value: "9.2", label: "IOS 9.2 及以上" },
  { value: "9.3", label: "IOS 9.3 及以上" },
  { value: "10.1", label: "IOS 10.1 及以上" },
  { value: "10.2", label: "IOS 10.2 及以上" },
  { value: "10.3", label: "IOS 10.3 及以上" },
  { value: "11.0", label: "IOS 11.0 及以上" },
  { value: "11.1", label: "IOS 11.1 及以上" },
  { value: "11.2", label: "IOS 11.2 及以上" },
  { value: "11.3", label: "IOS 11.3 及以上" },
  { value: "11.4", label: "IOS 11.4 及以上" },
  { value: "12.0", label: "IOS 12.0 及以上" },
  { value: "12.1", label: "IOS 12.1 及以上" },
  { value: "12.2", label: "IOS 12.2 及以上" },
  { value: "12.3", label: "IOS 12.3 及以上" },
  { value: "12.4", label: "IOS 12.4 及以上" },
  { value: "13.0", label: "IOS 13.0 及以上" },
  { value: "13.1", label: "IOS 13.1 及以上" },
  { value: "13.2", label: "IOS 13.2 及以上" },
  { value: "13.3", label: "IOS 13.3 及以上" },
  { value: "13.4", label: "IOS 13.4 及以上" },
  { value: "14.0", label: "IOS 14.0 及以上" },
];

export const inventory_type_list = [
  { value: "INVENTORY_FEED", label: "今日头条", icon: "toutiao" },
  { value: "INVENTORY_TOMATO_NOVEL", label: "番茄小说", icon: "tomato_novel_app" },
  { value: "INVENTORY_VIDEO_FEED", label: "西瓜视频", icon: "video_app" },
  { value: "INVENTORY_AWEME_FEED", label: "抖音", icon: "aweme" },
  { value: "UNION_BOUTIQUE_GAME", label: "ohayoo精品游戏", icon: "ohayoo" },
];

export const age_type_list = [
  { value: "AGE_BETWEEN_18_23", label: "18-23" },
  { value: "AGE_BETWEEN_24_30", label: "24-30" },
  { value: "AGE_BETWEEN_31_40", label: "31-40" },
  { value: "AGE_BETWEEN_41_49", label: "41-49" },
  { value: "AGE_ABOVE_50", label: "50+" },
];

export const more_age_type_list = [
  { value: "AGE_BETWEEN_18_19", label: "18-19" },
  { value: "AGE_BETWEEN_20_23", label: "20-23" },
  { value: "AGE_BETWEEN_24_30", label: "24-30" },
  { value: "AGE_BETWEEN_31_35", label: "31-35" },
  { value: "AGE_BETWEEN_36_40", label: "36-40" },
  { value: "AGE_BETWEEN_41_45", label: "41-45" },
  { value: "AGE_BETWEEN_46_50", label: "46-50" },
  { value: "AGE_BETWEEN_51_55", label: "51-55" },
  { value: "AGE_BETWEEN_56_59", label: "56-59" },
  { value: "AGE_ABOVE_60", label: "60+" },
];

export const action_scene_type_list = [
  { value: "E-COMMERCE", label: "电商互动行为" },
  { value: "NEWS", label: "资讯互动行为" },
  { value: "APP", label: "APP推广互动行为" },
  { value: "SEARCH", label: "搜索活动行为" },
];

export const device_type_list = [
  { value: "MOBILE", label: "智能手机" },
  { value: "PAD", label: "平板" },
];

export const hide_if_converted_type_list = [
  { value: "NO_EXCLUDE", label: "不过滤" },
  { value: "AD", label: "广告计划" },
  { value: "CAMPAIGN", label: "广告组" },
  { value: "ADVERTISER", label: "广告账号" },
  { value: "CUSTOMER", label: "公司账户" },
  { value: "APP", label: "APP" },
];

export const filter_time_type_list = [
  { value: "TODAY", label: "当天" },
  { value: "SEVEN_DAY", label: "7天" },
  { value: "ONE_MONTH", label: "1个月" },
  { value: "THREE_MONTH", label: "3个月" },
  { value: "SIX_MONTH", label: "6个月" },
  { value: "TWELVE_MONTH", label: "12个月" },
];

export const carrier_type_list = [
  { value: "MOBILE", label: "移动" },
  { value: "UNICOM", label: "联通" },
  { value: "TELCOM", label: "电信" },
];

export const activate_type_list = [
  { value: "WITH_IN_A_MONTH", label: "一个月内" },
  { value: "ONE_MONTH_2_THREE_MONTH", label: "一到三月" },
  { value: "THREE_MONTH_EAILIER", label: "三个月以上" },
];
export const auto_extend_targets_type_list = [
  { value: "AGE", label: "年龄" },
  { value: "REGION", label: "地域" },
  { value: "GENDER", label: "性别" },
  { value: "INTEREST_ACTION", label: "行为兴趣" },
  { value: "CUSTOM_AUDIENCE", label: "自定义人群" },
];

export const smart_bid_type_list = [
  { value: "SMART_BID_CUSTOM", label: "常规投放" },
  { value: "SMART_BID_CONSERVATIVE", label: "放量投放" },
  { value: "SMART_BID_NO_BID", label: "最大转化投放" },
];

export default {
  android_osv_list,
  ios_osv_list,
};
